module.exports = __webpack_public_path__ + "img/home.eb068a26.svg";